<template>
  <div id='ae' class='' v-loading='loading'>
    
    

    <el-dialog class='gDia' :title="$t('app_tobenimportdv')" v-model="isAddInfo" @open=open @close='close'>
      <div>
        <el-form ref='iform' :rules='iRules' :model="addInfo">
          <el-form-item label-width='14.5%'>
            <p>{{numTip}}</p>
          </el-form-item>
          <el-form-item label-width='14.5%'  :label="$t('app_firm')" prop='firm'>
            <el-select id="terminal_type" v-model="addInfo.firmarr" filterable clearable :placeholder="$t('terminal.add.place_manufid')" class="">
              <el-option v-for="item in firms" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select> 
            <!-- <el-cascader
              expand-trigger="hover" 
              :options="firms"
              :show-all-levels="false"
              v-model="addInfo.firmarr"
            ></el-cascader> -->
          </el-form-item>
          <el-form-item label-width='14.5%' :label="$t('lin_global.label_type')" prop='type'>
            <el-select id="terminal_type" v-model="addInfo.typearr" filterable clearable :placeholder="$t('terminal.add.place_type')" class="">
              <el-option v-for="item in dvTypes" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select> 
            <!-- <el-cascader
              expand-trigger="hover"
              :options="dvTypes"
              :show-all-levels="false"
              v-model="addInfo.typearr"
            ></el-cascader> -->
          </el-form-item>
          <el-form-item label-width='14.5%' :label="$t('lin_global.label_model')" prop='no'>
            <el-select id="terminal_model" v-model="addInfo.noarr" filterable clearable :placeholder="$t('terminal.add.place_model')" class="">
              <el-option v-for="item in models" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
            <!-- <el-cascader
              expand-trigger="hover"
              :options="models"
              :show-all-levels="false"
              v-model="addInfo.noarr"
            ></el-cascader> -->
          </el-form-item>
          <el-form-item label-width='14.5%' :label="$t('app_addres')" prop='address'>
            <el-input style='' v-model='addInfo.address'></el-input>
          </el-form-item>
          <el-form-item label-width='14.5%'>
            <el-button type="" @click="isAddInfo = false">{{$t('app_cancel')}}</el-button>
            <el-button type="primary" @click="importOrder">{{$t('terminal.list.import_btn')}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>


    <el-dialog class='gDia' :title="$t('terminal.list.import_title')" v-model="importTermVisible"  size="tiny" top="15%" :show-close="!importIsSubmit">
      <el-form style='background:none;' class='gDiaTable' :model="importForm" ref="importForm" id="importForm" label-width="" enctype='multipart/form-data'>
            <el-form-item label="" prop="uploadify" :rules="[{ required: true, message: this.$t('lin_global.qxzscwj') }]">
              <el-upload
                class="upload-demo"
                ref="upload"
                name="fileUpload"
                :action="action"
                xxxon-preview="handlePreview"
                :file-list="fileList"
                :show-file-list="false"
                :on-success="handleAvatarScucess"
                :auto-upload="false"
                :on-remove='rmFile'
                :on-change="beforeUpload">
                
                <el-button slot="trigger" size="small" type="primary">{{$t('terminal.list.xqwj')}}</el-button>
                
          
                <el-button :disabled="!exFileName" style="margin-left: 10px;" size="small" type="success" @click="submitUpload">{{$t('terminal.list.qrdr')}}</el-button>

                <div slot="tip" class="el-upload__tip">{{$t('terminal.list.excel_tips')}}</div>
                
                <div style='font-size:13px;' v-show='true'>
                  <label>{{$t('app_filename')}}:</label>&nbsp;&nbsp;<label>{{exFileName}}</label>
                </div>
              </el-upload>
            </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
          <a :href="importTemplate" style="margin-right:10px;"><el-button type="success">{{$t('terminal.list.import_muban')}}</el-button></a><!--  :href="importTemplate" -->
          <el-button @click="exCancel"  id="cancelBtn">{{$t('lin_btn.cancel')}}</el-button>
        <!--  <el-button type="primary" :loading="importIsSubmit" @click="excelUpload" id="saveBtn">保 存</el-button> -->
          </div>
    </el-dialog>

    <el-dialog  class='gDia' :title="$t('app_lineimportdevice')" v-model="showDvDia" size='small'>
      <div class='gBorder' style="margin-top:0px;">
        <el-row>
          <el-col :span='12'>
            <div class='gSgLeftBtn'>
              <el-button :disabled="orderselecet.length == 0" type='primary' @click='showDvDia=false;isAddInfo=true'>{{$t('app_importslorder')}}</el-button>
            </div>
          </el-col>
         
          <el-col :span='6'> 
            <div class='gCtrl'>
              <el-input  :placeholder="$t('app_customername')" v-model='cusEvent' @keyup.enter.native='queryOrder' icon="search" :on-icon-click="queryOrder"></el-input>
            </div>
          </el-col>
          <el-col :span='6'>
            <div class='gSideCtrl'>
              <el-input  :placeholder="$t('app_orderno')" v-model='orderEvent' @keyup.enter.native='queryOrder' icon="search" :on-icon-click="queryOrder"></el-input>
            </div>
          </el-col>
        </el-row>
        <div id=''>
          <el-table
            @row-click='cellClick'
            ref="multipleTable"
            :data="pageOrders"
            border
            class='gTopMg'
            @selection-change="orderSelected"
            style="width: 100%;border:none;">
            <el-table-column
              type="selection"
              align='center'
              width="55">
            </el-table-column>
            <el-table-column
              header-align='center'
              align='center'
              prop="orderNo"
              :label="$t('app_orderno')"
              width="">
            </el-table-column>

            <el-table-column
              header-align='center'
              align='center'
              prop="customerName"
              :label="$t('app_customername')"
              width="">
            </el-table-column>
          
            <el-table-column
              header-align='center'
              align='center'
              prop="terminalNum"
              :label="$t('app_deviceNum')"
              width="">
            </el-table-column>
          
            <!-- :formatter="dateFormat" -->
            <el-table-column
              header-align='center'
              align='center'
              prop="orderCompleteTime"
              
              width='172'
              :label="$t('app_orderfinishdate')">
            </el-table-column>

            
          </el-table>

          <div class="gPgDiv" style=''>
            <el-pagination
            class='gPg'
            @current-change="pageOrderChange"
            @size-change="pageSized"
            :current-page="pageOrder"
            :page-sizes='$gRows'
            :page-size="$gRow"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageOrderTotal">
            </el-pagination>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog  class='gDia' :title="$t('app_plimportcer')" v-model="showCerDia" size='small'>
      <div class='gBorder' style="margin-top:0px;">
        <el-row>
          <el-col :span='14'>
            <div class='gSgLeftBtn'>
              <el-button type='primary' :disabled="!cerselecet" @click='importCus'>{{$t('app_importslcustomer')}}</el-button>
            </div>
          </el-col>
         
          <el-col :span='10'>
            <div class='gSideCtrl'>
              <el-input  :placeholder="$t('app_customername') + ' & ' + $t('app_customerno')" v-model='cerEvent' @keyup.enter.native='queryCers' icon="search" :on-icon-click="queryCers"></el-input>
            </div>
          </el-col>
        </el-row>
        <div id=''>
          <el-table
            @row-click='cellClick'
            highlight-current-row
            ref="singleTable"
            :data="pageCers"
            border
            class='gTopMg'
            @current-change="selectedCer"
            style="width: 100%;border:none;">
            <!-- <el-table-column
              type="selection"
              align='center'
              width="55">
            </el-table-column> -->
            <el-table-column
              header-align='center'
              align='center'
              prop="certificateName"
              :label="$t('lin_global.certificateName')"
              width="">
            </el-table-column>

            <el-table-column
              header-align='center'
              align='center'
              prop="certificateType"
              :label="$t('lin_global.certTypeLabel')"
              width="">
              <template slot-scope='scope'>
                <label v-if='scope.row.certificateType==0'>{{$t('app_cerMgSelf')}}</label>
                <label v-if='scope.row.certificateType==1'>{{$t('app_cerMgOther')}}</label>
              </template>
            </el-table-column>
          
            <el-table-column
              header-align='center'
              align='center'
              prop="customerName"
              :label="$t('app_customername')"
              width="">
            </el-table-column>
          

            <el-table-column
              header-align='center'
              align='center'
              prop="customerNo"
              width='172'
              :label="$t('app_customerno')">
            </el-table-column>

            
          </el-table>

          <div class="gPgDiv" style=''>
            <el-pagination
            class='gPg'
            @current-change="pageCerChange"
            @size-change="pageSized"
            :current-page="pageCer"
            :page-sizes='$gRows'
            :page-size="$gRow"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageCerTotal">
            </el-pagination>
          </div>
        </div>
      </div>
    </el-dialog>

  
    <div class='gPageBorder'>
      <div style='background:white;display:inline-block;width:calc(100% - 40px);height:100%;padding: 0 20px 0 20px;'>
        <div style='height:64px;'>
          <button class='dt-mc-word-main' style='padding:0;height:100%;font-size:22px;background:none;border:none;'>{{info ? info.mechanismname : ''}}</button>
        </div>
        <div style='height:60px;'>
          <table class='dt-mc-app'>
            <tr>
              <td>
                <label class='dt-mc-word-title'>{{$t('app_channellevel')}}：</label>
                <label class='dt-mc-word-main'>{{info? info.mechanismgrade : ''}}</label>
              </td>
              <td>
                <label class='dt-mc-word-title'>{{$t('app_dParent')}}：</label>
                <label class='dt-mc-word-main'>{{info? info.memo : ''}}</label>
              </td>
              <td>
                <label class='dt-mc-word-title'>{{$t('app_cerType')}}：</label>
                <label class='dt-mc-word-main'>
                  {{info?cerTypes[info.certType]: ''}}
                </label>
              </td>
              <td>
                <!-- <label class='dt-mc-word-title'>{{$t('app_deviceNum')}}：</label>
                <label class='dt-mc-word-main'>{{config? config.data.versioncode : ''}}</label> -->
              </td>
            </tr>
            <tr>
              <td>
                <label class='dt-mc-word-title'>{{$t('app_contact')}}：</label>
                <label class='dt-mc-word-main'>{{info?info.completename : ''}}</label>
              </td>
              <td>
                <label class='dt-mc-word-title'>{{$t('app_contactPhone')}}：</label>
                <label class='dt-mc-word-main'>{{info?info.mechanismcode : ''}}</label>
              </td>
              <td style="background:white;" colspan="2">
                <label class='dt-mc-word-title'>{{$t('app_addres')}}：</label>
                <label>{{info?info.mechanismaddre : ''}}</label>
              </td>
              <!-- <td>
                <label class='dt-mc-word-title'>{{$t('app_insType')}}：</label>
                <label class='dt-mc-word-main'>{{setInstallType(config.data.appInstallType)}}</label>
              </td> -->
              <td></td>
            </tr>
          </table>
        </div>
        <!-- <div style='min-height:60px;display:flex;display:-webkit-flex;'>
          <div class='dt-mc-word-title' style='display:inline-block;min-width:70px;'>
            {{$t('app_introl')}}：
          </div>
          <div class='dt-mc-word-main' style='display:inline-block;position:relative;background:none;margin: 0 24px 24px 0;'>
            <pre>{{config.data.appDesc}}</pre>
          </div>
        </div> -->
      </div>
    </div>
     
    
    <!-- cer manage -->
    <span v-show='isShowModel'>
      <div class='gPageBorder gTopMg'  style=''>
        
        <p class='gCtColor gPTitle' style=''>{{$t('app_cermanage')}} </p>

        <el-button  v-show="showUploadNew"  @click='uploadCer' type='primary' style='margin: 24px 0 24px 24px' class=''>{{$t('app_uploadCer')}}</el-button>

        <el-button  v-show="showUploadNew"  @click='lineImportCer' type='primary' style='margin: 24px 0 24px 10px' class=''>{{$t('app_lineimportcer')}}</el-button>

        <el-button :disabled="cers.length == 0" v-show="showUploadNew"  @click='delCer' type='primary' style='margin: 24px 0 24px 10px' class=''>{{$t('app_delcer')}}</el-button>

        <el-table
          :data="cers"
          border
          style="width: 100%;">
          <el-table-column
            header-align='center'
            align='center'
            prop="certificateName"
            :label="$t('lin_global.certificateName')"
            width="">
          </el-table-column>
          <el-table-column
            header-align='center'
            align='center'
            prop="certificateType"
            width=''
            :label="$t('app_cerType')">
            <template slot-scope="scope">
              <label>{{cerTypes[scope.row.certificateType]}}</label>
            </template>
          </el-table-column>
          <el-table-column
            header-align='center'
            align='center'
            prop="md5"
            width=''
            label="MD5">
          </el-table-column>
        
          <el-table-column
            header-align='center'
            align='center'
            fformatter="dateFormat"
            prop="createTime"
            width='170'
            :label="$t('app_createTime')">
          </el-table-column>
          <!-- <el-table-column
            header-align='center'
            align='center'
            prop=""
            width='90'
            :label="$t('app_operate')">
            <template slot-scope='scope'>
              
              <el-tooltip class="item" effect="dark" :content="$t('app_del')" placement="top">
                <el-button type='text' v-show="config.data.isoperation === 0" @click='deleteAppHis(scope.row)'><i class="fa fa-trash-o" style="color:#FF4949"></i></el-button>
              </el-tooltip>

            </template>
          </el-table-column> -->
        </el-table>
      </div>

      <div class='gPageBorder gTopMg' style=''>
        
        <p class='gCtColor gPTitle' style=''>{{$t('app_devicemanage')}} </p>

        <el-button  v-show="showUploadNew"  @click='importDvFile' type='primary' style='margin: 24px 0 24px 24px' class=''>{{$t('app_fileimportdevice')}}</el-button>

        <el-button  v-show="showUploadNew"  @click='lineImportDv' type='primary' style='margin: 24px 0 24px 10px' class=''>{{$t('app_lineimportdevice')}}</el-button>

        <el-table
          :data="dvs"
          border
          @sort-change="sortChange"
          style="width: 100%;">
          <el-table-column
            header-align='center'
            align='center'
            prop="terminalName"
            :label="$t('app_deviceName')"
            width="">
          </el-table-column>
          <el-table-column
            header-align='center'
            align='center'
            sortable="custom"
            prop="terminalNo"
            width=''
            :label="$t('app_deviceNo')">
          </el-table-column>
          <el-table-column
            header-align='center'
            align='center'
            prop="terminalModelName"
            width=''
            :label="$t('app_prodmodel')">
          </el-table-column>
        
          <el-table-column
            header-align='center'
            align='center'
            sortable="custom"
            ffformatter="dateFormat"
            prop="terminalCreateTime"
            width='170'
            :label="$t('app_addtime')">
          </el-table-column>
          <!-- <el-table-column
            header-align='center'
            align='center'
            prop=""
            width='90'
            :label="$t('app_operate')">
            <template slot-scope='scope'>
              
              <el-tooltip class="item" effect="dark" :content="$t('app_del')" placement="top">
                <el-button type='text' v-show="config.data.isoperation === 0" @click='deleteAppHis(scope.row)'><i class="fa fa-trash-o" style="color:#FF4949"></i></el-button>
              </el-tooltip>

            </template>
          </el-table-column> -->
        </el-table>
        <div class="gPgDiv" style=''>
            <el-pagination
            class='gPg'
            @current-change="dvChange"
            @size-change="pageSized"
            :current-page="dvPage"
            :page-sizes='$gRows'
            :page-size="$gRow"
            layout="total, sizes, prev, pager, next, jumper"
            :total="dvTotal">
            </el-pagination>
          </div>
      </div>

    </span>

    <ssub  :tmcid='premcid' class="gTopMg"></ssub>

    

  </div>
</template>

<style>
  .dt-mc-word-main{color:rgb(72,87,106)}
  .dt-mc-word-title{color:#99A9BF;}

  pre{
    white-space: pre-wrap;
    word-wrap: break-word;
    white-space: -moz-pre-wrap;
    white-space: -pre-wrap;
    white-space: -o-pre-wrap;
    word-break:break-all;
  }

  .dt-mc-app{width:100%;height:100%;}
    .dt-mc-app td{width:25%;}

  /* upload */
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .capture {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width:120px;
    display:inline-block;
  }
  .capture div{float:left;}

  .avatar-uploader .el-upload:hover {
    border-color: #20a0ff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 128px;
    height:128px;
    line-height: 128px;
    text-align: center;
  }

  /* upload */
  .sm-avatar-uploader-icon {
    font-size: 36px;
    color: #8c939d;
    width: 72px;
    height:72px;
    line-height: 72px;
    text-align: center;
  }
  .sm-avatar { 
    width: 64px;
    height: 64px;
    display: block;
  }
 
</style>

<script>
  import ssub from '../account/accMess'
  import mm from 'moment'
  import df from '../../assets/df.png'
  import {isShowProductLineModel, urlAssets, baseurl} from '../../api/url'
  
  export default {
    components:{
      ssub
    },
    data () {
      return {
        sortNo: '',
        sortTime: '',
        iRules: {
          firm: [
            { required: true, message: this.$t('terminal.add.place_manufid'), trigger: 'blur' }
          ],
          type: [
            { required: true, message: this.$t('terminal.add.place_type'), trigger: 'blur' }
          ],
          no: [
            { required: true, message: this.$t('terminal.add.place_model'), trigger: 'blur' }
          ],
          address: [
            { required: true, message: this.$t('app_input'), trigger: 'blur' }
          ]
        },
        firms: [],
        dvTypes: [],
        models: [],
        premcid: '',
        addInfo: {
          firmarr: '',
          typearr: '',
          noarr: '',
          address: null,
          firm: null,
          type: null,
          no: null,
          sobj: []
        },
        isAddInfo: false,
        pageOrder: 1,
        pageOrderTotal: 0,
        pageOrders: [],
        orderselecet: [],
        cerEvent: '',

        pageCer: 1,
        pageCerTotal: 0,
        pageCers: [],
        cerselecet: '',
        orderEvent: '',
        cusEvent: '',

        dvPage: 1,
        dvTotal: 0,
        dvs: [],

        config: '',
        captures: [],
        loading: 0,
        showDvDia: false,
        showCerDia: false,
        cerTypes: [
          this.$t('app_cerMgSelf'),
          this.$t('app_cerMgOther'),
          this.$t('app_cerMgCustomer')
        ],
        sData: [],
        info: '',
        cers: [],
        // upload
        importTermVisible: false,
        
        exFileName: '',
        fileList:[],
        action: `${baseurl}/terminal/importTers.do`+"?language="+ localStorage.getItem("system_lang") + '&token=' + localStorage.user,
        importIsSubmit: false,
        importTemplate: `${urlAssets.prefix}tms-server-web/model/terminals.xlsx`
      }
    },
    computed: {
      numTip () {
        var str = this.$t('app_lineimporttip')
        return str
      },
      isShowModel () {
        // return isShowProductLineModel
        return localStorage.userType == 0
      },
      avtStyle () {
        var url = this.config.data.appBigIcon ? this.imgFullUrl(this.config.data.appBigIcon) : require('../../assets/df.png')
        
        return 'background-size: cover;background-position: center center;width:100%;height:100%;background-image: url(' + url + ')'
      },
      showUploadNew () {
        // if (this.config.data) {
        //   if (this.config.data.isoperation === 0 && this.config.data.appStatus === '2') {
        //     return true
        //   } else {
        //     return false
        //   }
        // } else {
        //   return false
        // }
        
        return true
      }
    },
    methods: {
      sortChange (vl) {
        switch (vl.prop) {
          case 'terminalNo':
            this.sortNo = vl.order == 'descending'? 'desc':'asc'
            this.sortTime = ''
            break
          case 'terminalCreateTime':
            this.sortTime = vl.order == 'descending'? 'desc':'asc'
            this.sortNo = ''
            break
        }
        this.getDvs()
      },
      delCer () {
        this.$confirm(this.$t('lin_global.confirmDelete'), this.$t('app_tip'), {
            confirmButtonText: this.$t('app_sure'),
            cancelButtonText: this.$t('app_cancel'),
            type: 'warning'
          }).then(() => {
            // console.log(this.cers)
            var data = this.cers[0]

            this.loading = 1
            this.$delcer(data.certificateId, (res) => {
              this.loading = 0
              if (res.status === 200) {
                // this.getAppHistory()
                this.cerList()
              } else {
                this.$message.error(res.message)
              }
            }, () => {
              // error
              this.loading = 0
            })
          }).catch(() => {
          })
      },
      handleAvatarScucess(res, file) {
          //console.log("打印上传后返回");
        
          this.exCancel()

          if(res.status == 200){
            //this.$message.success(res.message);
            this.$notify({
              title: this.$t('terminal.list.notify_title'),
              message: res.message,
              type: 'success',
              duration: 6000
            });
            
            var _this = this
            setTimeout(() => {
              _this.getDvs()
            }, 800)
            
          }else{
            this.$notify.error({
              title: this.$t('terminal.list.notify_title'),
              message: res.message,
              duration: 6000
            });
            //this.$message.error(res.message);
          }

      },
      importCus () {
        console.log(this.info)
        this.loading = 1
        this.$importLineCer(this.cerselecet.id, this.info.mechanismid, (res) => {
          this.loading = 0
          if (res.status === 200) {
            this.$message.success(res.message)
            this.cerList()
            this.showCerDia=false
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          // error
          this.loading = 0
        })
      },
      importOrder () {

        this.addInfo.firm = this.addInfo.firmarr?this.addInfo.firmarr:''
        this.addInfo.type = this.addInfo.typearr?this.addInfo.typearr:''
        this.addInfo.no = this.addInfo.noarr?this.addInfo.noarr:''


        this.$refs['iform'].validate(valid => {
          if (valid) {
            var nos = ''
            this.orderselecet.forEach((vl) => {
              nos += vl.orderNo + ','
            })
            nos = nos.substring(0,nos.length - 1)
            
            var mc = this.info.mechanismid
            mc = mc ? mc : ''
            this.loading = 1

           
            this.$importLineOrder(nos, mc, this.addInfo.firm , this.addInfo.type, this.addInfo.no, this.addInfo.address, (res) => {
              this.loading = 0
              if (res.status === 200) {
                this.$message.success(res.message)
                this.isAddInfo = false
                this.getDvs()
              } else {
                this.$message.error(res.message)
              }
            }, () => {
              // error
              this.loading = 0
            })
          } else {
            return false;
          }
        });

        
        

        
      },
      pageCerChange (index) {
        this.pageCer = index
        this.getCerList()
      },
      queryCers () {
        this.getCerList()
      },
      submitUpload() {
        
        this.$refs.upload.submit();
      },
      selectedCer (vl) {
        this.cerselecet = vl
      },
      pageOrderChange (index) {
        this.pageOrder = index
        this.getOrderList()
      },
      getCerType (vl) {
        var data = [
          this.$t('app_cerMgSelf'),
          this.$t('app_cerMgOther'),
          this.$t('app_cerMgCustomer')
        ]
        return data[0]
      },
      dvChange (index) {
        this.dvPage = index
        this.getDvs()
      },
      cerList () {
        this.loading = 1
        this.$getChannelCer(this.info.mechanismid, (res) => {
          this.loading = 0
          if (res.status === 200) {
            if (res.data) {
              this.cers = [res.data]
            } else {
              this.cers = []
            }
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          // error
          this.loading = 0
        })
      },
      queryOrder () {
        this.getOrderList()
      },
      getOrderList () {
        this.loading = 1
        var orderNo = this.orderEvent
        var customerName = this.cusEvent
        this.$channelOrders(this.pageOrder, this.$gRow, orderNo, customerName, (res) => {
          this.loading = 0
          if (res.status === 200) {
            this.pageOrders = res.data
            this.pageOrderTotal = res.total
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          // error
          this.loading = 0
        })
      },
      getCerList () {
        this.loading = 1 
        var customerName = this.cerEvent
        this.$channelCers(this.pageCer, this.$gRow, customerName, (res) => {
          this.loading = 0
          if (res.status === 200) {
            this.pageCers = res.data
            this.pageCerTotal = res.total
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          // error
          this.loading = 0
        })
      },
      rmFile (file) {
      },
      beforeUpload(file){
        this.exFileName = file.name
      },
      exCancel () {
				this.importTermVisible = false
        this.file = ''
        // this.exFileName = ''
        
				if(this.exFileName) {
					this.$router.push({path: '/'})
					this.$router.go(-1)
				}
      },
      orderSelected (list) {
        this.orderselecet = list 
      },
      handleSelectionChange (list) {
        // console.log(list)
        this.sData = list
      },
      lineImportDv () {
        this.showDvDia = true
      },
      importDvFile () {
        // this.exCancel()
        
        this.importTermVisible = true
      },
      lineImportCer () { 
        this.showCerDia = true
      },
      uploadCer () {
        this.$setWObj('cnUploadId', this.info.mechanismid)
        this.$router.push({path: '/certificate/upload'})
      },
      setInstallType (type) {
        return this.$installType[type]
      },
      dateFormat (row, column) { 
        // var date = row[column.property]
        // if (date === undefined) {
        //   return ''
        // }
        // return mm(date).format('YYYY-MM-DD hh:mm:ss')
      },
      selectChange (vl) {
        this.getDevices()
      },
      pageSelect (index) {
        this.index = index
        this.getDevices()
      },
      pageSized (val) {
        this.$gRow = val
        // this.getDevices()
        this.getOrderList()
        this.init()
      },
     


      deleteAppHis (row) {
        // console.log(row)
        if (row.applicationid) {
          this.$confirm(this.$t('app_tipAppEdit'), this.$t('app_tip'), {
            confirmButtonText: this.$t('app_sure'),
            cancelButtonText: this.$t('app_cancel'),
            type: 'warning'
          }).then(() => {
            this.loading = 1
            if (this.$appUrlTag === 0) {
              this.$deleteApp(row.applicationid, (res) => {
                this.loading = 0
                if (res.status === 200) {
                  this.getAppHistory()
                } else {
                  this.$message.error(res.message)
                }
              }, () => {
                // error
                this.loading = 0
              })
            } else {
              this.$deleteAppHis(row.applicationid, (res) => {
                this.loading = 0
                if (res.status === 200) {
                  this.getAppHistory()
                } else {
                  this.$message.error(res.message)
                }
              }, () => {
                // error
                this.loading = 0
              })
            }
          }).catch(() => {
          })
        }
      },
 
      imgFullUrl (path) {
        if (path) {
          // return this.$host + path
          // console.log('imgpath', path, this.$urls.prefix + path)
          return this.$urls.prefix + path
        } else {
          return ''
        }
      },

      getAppHistory () {
        if (!this.config.data.appName) {
          return
        }
        // console.log('pkg', this.config.data)
        this.loading = 1
        if (this.$appUrlTag === 0) {
          this.$getAppHistory(this.config.data.appName, this.config.data.packagename, (res) => {
            //console.log('his', res)
            //alert(res)
            this.loading = 0
            if (res.status === 200) {
              this.tableData = res.data
            } else {
              this.$message.error(res.message)
            }
          }, () => {
            // error
            this.loading = 0
          })
        } else {
          
          this.$getAppHistory1(localStorage.mechanismId, this.config.data.packagename, (res) => {

            console.log('his', res)
            this.loading = 0
            if (res.status === 200) {
              this.tableData = res.data
            } else {
              this.$message.error(res.message)
            }
          }, () => {
            // error
            this.loading = 0
          })
        }
        
      },
      uploadNew () {
        // this.config = {type: 4, data: this.config}
        // /newversion 
        //this.$router.push({name: this.$t('menu.appManageSub.uploadNew')})
        this.$router.push({path: '/applist/newversion'})
      },
      setCapturesArr (strs) {
        if (strs) {
          var arr = strs.split(',')
          this.captures = arr
        }
      },
      getDvs () {
        var mcid = this.info.mechanismid
        mcid = mcid ? mcid : ''
        this.loading = 1
        this.$getDvDevices(this.dvPage, this.$gRow, mcid, '', '', '', this.sortNo, this.sortTime,'','', (res) => {
          
          this.loading = 0
          if (res.status === 200) { 
            this.dvs = res.data
            this.dvTotal = res.total
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          // error
          this.loading = 0
        })
      },
      init () {
        var _this = this
        setTimeout(() => {
          this.getDvs()
        }, 100)
        setTimeout(() => {
          this.getOrderList()
        }, 300)
        setTimeout(() => {
          this.getCerList()
        }, 300)
        
        this.cerList()


        var mc = this.info.mechanismid
        
        // this.$gpDvModel(mc, (res) => {
        //   this.models = res.data
        // }, '') 
        // this.$gpDvType(mc, (res) => {
        //   this.dvTypes = res.data
        // }, '') 
        // this.$gpFirm(mc, (res) => {
        //   this.firms = res.data
        // }, '') 
        this.$mechGetTypes(mc, res => {
					if (res.status == 200) {
						this.models = res.data.models
						this.dvTypes = res.data.types
						this.firms = res.data.manufactures
					}
				}, '') 
 
      }
    },
    mounted () {
      var data = this.$getWObj().appChannelDetail
      // console.log(data)
      this.premcid = data.mechanismid
      this.info = data
      this.init()
    }
  }
</script>



// WEBPACK FOOTER //
// channelDetail.vue?7ab3f942